import React, {useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router";
import otherDocumentTypeService from "../../../../services/web/other-document-type-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";

const OtherDocumentTypeForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [state, setState] = useState({name: ""});
    const [isLoading, setIsLoading] = useState(false);

    const onChange = ({target: {value, id}}) => handleInputs(value, id)

    const handleInputs = (value, id) => {
        setState(prev => ({...prev, [id]: value}));
    }

    const {refetch, isLoading: fetchIsLoading} = useQuery({
        queryFn: () => otherDocumentTypeService.get(id).then((data) => {
            setState(data)
            return [];
        }),
        queryKey: ['otherDocumentType', {id}],
        enabled: !!id,
    });

    const save = () => {
        const formData = new FormData();
        formData.append("name", state.name ?? "")

        if (id) formData.append('_method', 'PUT');

        setIsLoading(true);

        const response = id ? otherDocumentTypeService.edit(id, formData) : otherDocumentTypeService.create(formData);

        response.then(({data}) => {
            projectUtils.success(!id);
            if (id) {
                refetch();
                return;
            }

            navigate(`/otherDocumentTypes/form/${data.id}`);
        })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? message;
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false));

    }

    const destroy = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir o tipo de documento "${state.name}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    setIsLoading(true);

                    otherDocumentTypeService.destroy(id)
                        .then(() => {
                            projectUtils.success(true, "Excluído com sucesso");
                            navigate(`/otherDocumentTypes`);
                        })
                        .catch((error) => {
                            console.error(error);

                            const {message} = error.response.data;

                            let errMessage = AlertMessages[message] ?? "Não foi possível excluir.";
                            projectUtils.swalErrorMessage("", errMessage, "Ok");
                        })
                        .finally(() => setIsLoading(false));
                }
            }
        );
    }

    return (
        <Template isLoading={isLoading || fetchIsLoading}>
            <Template.Header>
                <Template.Title>
                    Tipo de documento
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => navigate(`/otherDocumentTypes/form`)}>
                            <FaPlus/>
                            Adicionar tipo de documento
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12">
                                <InputForm id="name" value={state.name} label="Nome *" onChange={onChange}/>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end ">
                            <div className="flex gap-2">
                                {
                                    id &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>

        </Template>
    );
};

export default OtherDocumentTypeForm;